import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectMemberRemovalFailedAction = {
	type: 'SUBJECT_MEMBER_REMOVAL_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectMemberRemovalFailedAction => ({
	type: 'SUBJECT_MEMBER_REMOVAL_FAILED',
	payload,
});
